import { BooleanStore } from 'stores';

import { Distances } from './distances';

const distancesStore = new Distances();
const collapseStore = new BooleanStore();

export { distancesStore, collapseStore };
export * from './distances';
